import React from 'react'
import styled from "styled-components";

const CenteredLayout = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  
  background-color: var(--it-bg-dark-2);

  &[data-error-page] {
    height: 80vh;
  }
`

const Centered = ({children, ...rest}) => (
  <CenteredLayout
    data-layout="centered"
    {...rest}
  >
    {children}
  </CenteredLayout>
)

export default Centered
